import i18n from "~/plugins/i18n";
export default {
    fields: [
        {
            key: "event",
            label: "Event",
            sorter: false,
            active: true,
            filter: false,
            _filter: false,
        },
        {
            key: "datetime",
            label: "Date event",
            sorter: false,
            active: true,
            filter: false,
            _filter: false,
        },
        {
            key: "email",
            label: "Email",
            sorter: false,
            active: true,
            filter: false,
            _filter: false,
        },
        {
            key: "message_id",
            label: "Message ID",
            sorter: false,
            active: true,
            filter: false,
            _filter: false,
        },
        {
            key: "template_id",
            label: "Template ID",
            sorter: false,
            active: true,
            filter: false,
            _filter: false,
        },
        {
            key: "reason",
            label: "Reason",
            sorter: false,
            active: true,
            filter: false,
            _filter: false,
        },
    ],
    allFields: [],
    items: [],
    order: "desc",
    rows: 20,
    currentPage: 1,
    matchResponseCurrentPage: "currentPage",
    pages: 1,
    matchResponsePages: "pages",
    loading: false,
    hover: true,
    pagination: false,
    sorter: {
        external: true,
        resetable: true
    },
    sorterValue: {},
    size: "sm",
    columnFilter: {
        external: true,
        lazy: true
    },
    columnFilterValue: {},
    itemsPerPageSelect: false,
    itemSelected: null,
    matchResponse: "items",
}